module.exports = __webpack_public_path__ + "static/media/PR3.425630f8.jpg";